<template>
  <div class="flex flex-col gap-2">
    <h2 class="text-lg font-bold text-left text-[#163D45] mb-4">Requisitos da escala</h2>

    <ComboBoxWithOther
      v-model="step2.positions"
      :items="positions"
      label="Selecione as posições da escala"
      :error="!!props.errors.positions"
      :error-message="props.errors.positions"
      @update:modelValue="props.onClearError('positions')"
    />

    <ComboBoxWithOther
      v-model="step2.shifts"
      :items="shifts"
      label="Selecione os turnos da escala"
      :error="!!props.errors.shifts"
      :error-message="props.errors.shifts"
      @update:modelValue="props.onClearError('shifts')"
    />

    <div class="flex items-center gap-3">
      <label
        class="text-sm font-bold transition-colors"
        :class="step2.formationRequired ? 'text-primary' : 'text-gray-400'"
      >
        Nível de formação necessário para a escala?
      </label>
      <DsSwitch v-model="step2.formationRequired" />
    </div>

    <ComboBoxWithOther
      v-model="step2.formations"
      :items="formations"
      label="Selecione o nível de formações necessário para a escala"
      :disabled="!step2.formationRequired"
      :error="!!props.errors.formations"
      :error-message="props.errors.formations"
      @update:modelValue="props.onClearError('formations')"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, inject } from 'vue'
import DsSwitch from '@/components/designSystem/Switch/index.vue'
import { useCreateScheduleStore } from '@/pinia-store/useCreateScheduleStore'
import { storeToRefs } from 'pinia'
import ComboBoxWithOther from './ComboBoxWithOther.vue'
import FieldOptionsService from '@/Network/Services/FieldOptionsService'

const store = (inject('createScheduleStore') ?? useCreateScheduleStore()) as ReturnType<
  typeof useCreateScheduleStore
>
const { step2 } = storeToRefs(store)

type Item = { title: string; value: number }

const positions = ref<Item[]>([])
const formations = ref<Item[]>([])
const shifts = ref<Item[]>([])

const fieldService = new FieldOptionsService()

const fetchFieldOptions = async () => {
  try {
    const [positionResponse, shiftsResponse, formationResponse] = await Promise.all([
      fieldService.getPositions(),
      fieldService.getShifts(),
      fieldService.getFormations()
    ])

    positions.value = positionResponse.map((position) => ({
      title: position.name,
      value: position.id
    }))

    formations.value = formationResponse.map((formation) => ({
      title: formation.name,
      value: formation.id
    }))

    shifts.value = shiftsResponse.map((shift) => ({
      title: shift.name,
      value: shift.id
    }))
  } catch (error) {
    console.error('Erro ao carregar dados dos campos:', error)
  }
}

onMounted(fetchFieldOptions)

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = defineProps<{
  errors: Record<string, string>
  onClearError: (field: string) => void
}>()
</script>
